import { render } from "./NcHeader.vue?vue&type=template&id=4345301c&scoped=true"
import script from "./NcHeader.vue?vue&type=script&lang=js"
export * from "./NcHeader.vue?vue&type=script&lang=js"

import "./NcHeader.vue?vue&type=style&index=0&id=4345301c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4345301c"]])

export default __exports__